import { PrimaryButton, Spacer, theme } from '@dot/design-system';
import { useTranslation } from 'react-i18next';
import { default as styled } from 'styled-components';

import SadFaceIcon from '@/assets/icons/sad-face.svg?react';
import { SecuredByBadge } from '@/components/SecuredByBadge/SecuredByBadge';
import { PageWrapper } from '@/styles/GlobalStyles';
import { fontHeadingOne, fontTextMdRegular } from '@/styles/helpers';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 40.5rem;
  margin-inline: auto;
  text-align: center;
  color: ${theme.colors.oxfordBlue[80]};
`;

const Title = styled.h1`
  ${fontHeadingOne};
`;

const Subtitle = styled.p`
  ${fontTextMdRegular};
`;

export type MobilRedirectErrorProps = {
  onContinueOnThisDeviceClick?: () => void;
};

export const MobileRedirectError = ({ onContinueOnThisDeviceClick }: MobilRedirectErrorProps) => {
  const { t } = useTranslation();

  return (
    <PageWrapper>
      <Container>
        <Spacer $top={1.5}>
          <SadFaceIcon />
        </Spacer>
        <Spacer $top={1}>
          <Title>{t('steps.mobileRedirect.error.title')}</Title>
        </Spacer>
        {onContinueOnThisDeviceClick ? (
          <>
            <Spacer $bottom={2} $top={1}>
              <Subtitle>{t('steps.mobileRedirect.error.subtitle')}</Subtitle>
            </Spacer>
            <PrimaryButton
              data-test-id="btn_continue_on_this_device"
              onClick={onContinueOnThisDeviceClick}
              type="button"
            >
              {t('steps.mobileRedirect.returnButton')}
            </PrimaryButton>
          </>
        ) : (
          <Spacer $bottom={2} $top={1}>
            <Subtitle>{t('steps.mobileRedirect.error.subtitleMandatoryMobile')}</Subtitle>
          </Spacer>
        )}
        <Spacer $top={2}>
          <SecuredByBadge />
        </Spacer>
      </Container>
    </PageWrapper>
  );
};
